import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FL150 master + FL151 detail)
// ============================================================

export interface FL150 {
  fl150_01: string;          // 查檢表號 PK
  fl150_10: number;          // 次別 1=上半年 2=下半年
  fl150_11: string | null;   // 稽核日期 (ISO string)
  fl150_12: string;          // 部門代碼
  fl150_13: string;          // 受稽核人員工代號(表頭)
  fl150_14: string;          // 稽核人員工代號
  fl150_15: number;          // 總項數(自動更新)
  fl150_16: number;          // (備用)
  fl150_80: string;          // 狀態碼
  fl150_81: string;          // 管理代表員工代號
  fl150_82: string | null;   // (備用日期)
  fl150_91: string;          // 建檔人
  fl150_92: string | null;   // 建檔日期
  fl150_93: string;          // 建檔時間

  // Associations
  details?: FL151[];
}

export interface FL151 {
  fl151_01: string;          // 查檢表號 FK
  fl151_02: number;          // 項次
  fl151_03: string;          // 受稽核人員工代號
  fl151_03a: string;         // 受稽核人姓名(自動填入)
  fl151_04: string;          // 受稽核人部門代碼
  fl151_04a: string;         // 受稽核人部門名稱
  fl151_11: string;          // 章節代碼
  fl151_12: string;          // 確認事項
  fl151_21: string;          // 判定 Y/N/空白
  fl151_22: string;          // 稽核記錄
  fl151_23: string;          // (備用)
  fl151_91: string;          // 建檔人
  fl151_92: string | null;   // 建檔日期
  fl151_93: string;          // 建檔時間
  fl151_31: number;          // 累計傳送留言次數
  fl151_32: string | null;   // 最後傳送留言日期
}

// ============================================================
// Request / Response types
// ============================================================

export interface L205ListResponse {
  data: FL150[];
  total: number;
  page: number;
  size: number;
}

export interface L205CreateRequest {
  master: Partial<FL150>;
  details: Partial<FL151>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const l205Api = {
  async list(page = 1, size = 20): Promise<L205ListResponse> {
    const res = await apiClient.get('/api/l205', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FL150> {
    const res = await apiClient.get(`/api/l205/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: L205CreateRequest): Promise<FL150> {
    const res = await apiClient.post('/api/l205', data);
    return res.data;
  },

  async update(id: string, data: L205CreateRequest): Promise<FL150> {
    const res = await apiClient.put(`/api/l205/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/l205/${encodeURIComponent(id)}`);
  },
};
